import type {
    WebinarRoomAnsweringEventDto,
    WebinarRoomMessageEventDto,
    WebinarRoomMessageRemovedEventDto,
    WebinarRoomPeopleChangedEventDto,
    WebinarRoomPollClosedEventDto,
    WebinarRoomPollLaunchedEventDto,
    WebinarRoomPollTallyEventDto,
    WebinarRoomStateChangedEventDto,
} from '@/api/webinarRoom'

/**
 * Mirrors `WebinarRoomEvents` (api/OrbitalX.Business/Constants/WebinarRoom): change one, change the other. All but
 * the last go out on the `webinar` hub; `WebRoomRecordingChanged` is the dashboard's `orbitalx` hub.
 */
export const WebinarRoomEvents = {
    MessageUpserted: 'MessageUpserted',
    MessageRemoved: 'MessageRemoved',
    ModeratorAnswering: 'ModeratorAnswering',
    PollLaunched: 'PollLaunched',
    PollClosed: 'PollClosed',
    PollTally: 'PollTally',
    RoomStateChanged: 'RoomStateChanged',
    PeopleChanged: 'PeopleChanged',
    WebRoomRecordingChanged: 'WebRoomRecordingChanged',
} as const

/** What each `webinar` hub event carries. Every payload names its room, and a page drops any other room's. */
export interface RoomHubPayloads {
    MessageUpserted: WebinarRoomMessageEventDto
    MessageRemoved: WebinarRoomMessageRemovedEventDto
    ModeratorAnswering: WebinarRoomAnsweringEventDto
    PollLaunched: WebinarRoomPollLaunchedEventDto
    PollClosed: WebinarRoomPollClosedEventDto
    PollTally: WebinarRoomPollTallyEventDto
    RoomStateChanged: WebinarRoomStateChangedEventDto
    PeopleChanged: WebinarRoomPeopleChangedEventDto
}

export type RoomHubEvent = keyof RoomHubPayloads

export type RoomHubHandlers = { [Event in RoomHubEvent]: (payload: RoomHubPayloads[Event]) => void }

/** The events the room page listens for, in the order they are registered. */
export const ROOM_HUB_EVENTS: readonly RoomHubEvent[] = [
    WebinarRoomEvents.MessageUpserted,
    WebinarRoomEvents.MessageRemoved,
    WebinarRoomEvents.ModeratorAnswering,
    WebinarRoomEvents.PollLaunched,
    WebinarRoomEvents.PollClosed,
    WebinarRoomEvents.PollTally,
    WebinarRoomEvents.RoomStateChanged,
    WebinarRoomEvents.PeopleChanged,
]
